import React from 'react'

function Routes() {
    return <></>
  }
 
  Routes.global = {
    url_login: 'https://ai-od.com/pilar/apiOdin/usuarios/'
  };
  
  export default Routes;
